<template>
  <div
    id="home"
    @click="closeMenuOnOutsideClick"
    class="bs-template-owner-view"
  >
    <BsHeaderView @toggle="menuToggle" :attachLogo="goHome" :isMenuOpen="menuDisplay"></BsHeaderView>
    <div class="container-fluid main-content">
      <div style="display: none;">{{ owner_no }}</div>
      <div style="display: none;">{{ $store.state.oauth }}</div>
      <div class="row row-eq-height">
        <main :class="mainDisplayClass">
          <router-view></router-view>
        </main>
        <nav :class="['navi', {'navi--isOpen': menuDisplay}]" id="navi" @click.stop>
          <ul class="navi__ul">
            <li class="navi__li" v-for="menu in menu_list" :key="menu.label">
              <template v-if="menu.path == '/event/link'">
                <EventManageLink
                  :label="menu.label"
                  :load-owner-sso-token-obj="loadOwnerSsoTokenObj"
                />
                <!-- <a :href="get_event_manage_url" class="navi__a" target="_blank" v-else>
                  {{ menu.label }}
                  <font-awesome-icon
                    :icon="['fas', 'chevron-right']"
                    class="mx-2"
                  ></font-awesome-icon>
                </a> -->
              </template>
              <template
                  v-else-if="menu.path == '/owner_edit/entry_setting'"
              >
                <MsEventOwnerLink
                  v-if="get_owner_entry_system_target_id"
                  :label="'エントリー管理'"
                  :load-msevent-token-obj="loadMsEventTokenObj"
                />
                <MsEventOwnerLink
                  v-else-if="get_owner_entry_system && get_base_env!='production'"
                  :label="'エントリー管理'"
                  :load-msevent-token-obj="loadMsEventTokenObj"
                />
                <router-link v-else-if="!get_owner_entry_system && get_base_env!='production'" class="navi__a" :to="menu.path" @click="closeMenu">
                {{ menu.label }}
                <font-awesome-icon
                  :icon="['fas', 'chevron-right']"
                  class="mx-2"
                ></font-awesome-icon>
                </router-link>
              </template>
              <template v-else-if="menu.path == '/owner_request/continue'">
                <router-link class="navi__a" :to="menu.path" @click="closeMenu">
                {{ menu.label }}
                <font-awesome-icon
                  :icon="['fas', 'chevron-right']"
                  class="mx-2"
                ></font-awesome-icon>
                </router-link>
              </template>
              <router-link v-else class="navi__a" :to="menu.path" @click="closeMenu">
              {{ menu.label }}
              <font-awesome-icon
                :icon="['fas', 'chevron-right']"
                class="mx-2"
              ></font-awesome-icon>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <BsFooterView></BsFooterView>
  </div>
</template>

<script>
  import BsHeaderView from '../organisms/BsHeaderView.vue'
  import BsFooterView from '../organisms/BsFooterView.vue'
  import { mapState } from 'vuex'
  import config from '../../const'
  import EventManageLink from '@/components/templates/Event/EventManageLink.vue'
  import MsEventOwnerLink from '@/components/templates/MsEvent/OwnerLink.vue'

  export default {
    name: 'templateOwnerView',
    data: function () {
      return {
        menuDisplay: false,
      }
    },
    computed: {
      owner_no: function(){
        return this.$store.state.oauth.owner_no
      },
      get_owner_entry_system_target_id: function(){
        if(
          this?.$store?.state?.oauth?.entry_system == 1
          && ['00000001', '00000002', '00000018', '00001601', '00001611', '00001612', '00001613', '00001614', '00001615', '00000646'].includes(this?.owner_no)
        ){
          return true
        }
        return false
      },
      get_owner_entry_system: function(){
        if(
          this?.$store?.state?.oauth?.entry_system == 1
        ){
          return true
        }
        return false
      },
      get_event_manage_dmn: function(){
        if(
          this?.$store?.state?.oauth?.owner_no
        ){
          if(this.get_base_env=='production'){  
            return 'https://www.ms-event.net/mfj/admin/';
          }
          else if(this.get_base_env=='staging' || this.get_base_env=='mfj'){
            return 'https://staging.ms-event.net/mfj_renewal/event/'
          }
          else if(this.get_base_env=='sandbox'){
            return 'https://sandbox.ms-event.net/mfj_renewal/event/'
          }else{
            return 'https://localhost/mfj_renewal/event/'
          }
        }
        return false
      },
      get_event_manage_url: function(){
        if(
          this?.get_event_manage_dmn
        ){
          return this.get_event_manage_dmn + 'mfj_renewal_login.php?org_code=' + btoa(this.$store.state.oauth.owner_no) + ''
        }
        return false
      },
      get_msevent_manage_dmn: function(){
        if(
          this?.$store?.state?.oauth?.owner_no
        ){
          if(this.get_base_env=='production'){  
            return false
            // return 'https://www.ms-event.net/mfj/admin/';
          }
          else if(this.get_base_env=='staging' || this.get_base_env=='mfj'){
            return 'https://staging.ms-event.net/mfj_renewal/event/'
          }
          else if(this.get_base_env=='sandbox'){
            return 'https://sandbox.ms-event.net/mfj_renewal/event/'
          }else{
            return 'https://local7.ms-event.net:8443/mfjeweb/'
          }
        }
        return false
      },
      get_msevent_manage_url: function(){
        if(
          this?.get_msevent_manage_dmn
        ){
          return this.get_msevent_manage_dmn + 'admin/'
        }
        return false
      },
      ...mapState({}),
      menu_list() {
        return config.HEAD_MENU_OWNER_LIST.filter(
          (menu) => menu.menu_sort !== false
        ).sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
      },
      mainClass() {
        return this.menuDisplay ? 'col-12 col-md-9' : 'col-12'
      },
      sideMenuClass() {
        return 'col-12 col-md-3 ff_noto_sans fw-bold bs_fs_7 text-center side-menu'
      },
    },
    components: {
      BsHeaderView,
      BsFooterView,
      EventManageLink,
      MsEventOwnerLink,
    },
    async created() {
      console.log('get_event_manage_url', this.get_event_manage_url)
      console.log('get_event_manage_dmn', this.get_event_manage_dmn)
    },
    methods: {
      async goEventManage(){
        if(!this.get_event_manage_dmn){
          return false
        }
        const url = this.get_event_manage_dmn + '?a=mfj_login.admin_user_logout&org_code=' + btoa(this.$store.state.oauth.owner_no)
        await this.outServPosts(
          url,
          {}
        )
        .then(async (response) => {
            console.log('member_license_update response', response)
        })
        .catch(async (err) => {
            console.log(err)
        })
        .finally(async () => {
          window.location.href = this.get_event_manage_url
            this.$forceUpdate()
        })
      },
      goHome(){
        this.$router.push('/owner/mypage')
      },
      menuToggle() {
        this.menuDisplay = !this.menuDisplay // メニューの表示状態をトグル
      },
      closeMenu() {
        this.menuDisplay = false // メニューを閉じる
      },
      closeMenuOnOutsideClick(event) {
        if (
          this.menuDisplay &&
          !event.target.closest('.side-menu') &&
          !event.target.closest('.naviButton')
        ) {
          this.closeMenu() // 外側クリックでメニューを閉じる
        }
      },
      async loadMsEventTokenObj(){
        const params = {}
        params['stat'] = [1]
        params['id'] = this.get_auth.userId

        let token = ''
        try {
          token = await this.basicPosts_S(
            config.BASE_API_URL + '/owner/mseventtoken',
            params
          )
        } catch (err) {
          console.log(err)
        }

        return token
      },
      async loadOwnerSsoTokenObj() {
        const params = {}
        params['stat'] = [1]
        params['id'] = this.get_auth.userId

        let token = ''
        try {
          token = await this.basicPosts_S(
            config.BASE_API_URL + '/owner/ssotoken',
            params
          )
        } catch (err) {
          console.log(err)
        }

        return token
      },
    },
  }
</script>

<style scoped>
  @import '../../assets/bootstrap/css/dashboard.css';
  @import '../../assets/css/style-color02.css';

  .bs-template-owner-view .main-content {
    padding-top: 60px;
    min-height: calc(100vh - 60px);
    padding-bottom: 80px;
  }

  .bs-template-owner-view .side-menu {
    background-color: var(--color02);
    border-left: 1px solid var(--color07);
    position: fixed;
    right: -250px;
    top: 60px;
    bottom: 0;
    width: 250px;
    overflow-y: auto;
    z-index: 1000;
    transition: right 0.3s ease-in-out;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  }

  .bs-template-owner-view .side-menu.show {
    right: 0;
  }

  @media (max-width: 767px) {
    .bs-template-owner-view .side-menu {
      width: 100%;
      right: -100%;
    }
  }

  .bs-template-owner-view .menu-item {
    padding: 15px;
    border-bottom: 1px solid var(--color07);
    transition: background-color 0.2s ease;
    background-color: var(--color03);
  }

  .bs-template-owner-view .menu-item:hover {
    background-color: var(--color03);
  }

  .bs-template-owner-view .menu-item a {
    color: var(--color02);
    text-decoration: none;
    display: block;
  }

  .bs-template-owner-view .menu-item.active {
    background-color: var(--color03);
  }

  .bs-template-owner-view .menu-item.active a {
    color: var(--color02);
  }

  /* オーバーレイ効果（オプション） */
  .bs-template-owner-view .side-menu::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: -1;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    pointer-events: none;
  }

  .bs-template-owner-view .side-menu.show::before {
    opacity: 1;
  }
</style>
